module.exports = __webpack_public_path__ + "static/media/dollar.d9f962ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dollar.png
// module id = 282
// module chunks = 0